var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9609 51.7498L33.668 52.4542L34.3738 51.7485L61.1225 24.9997L65.5883 29.4972L33.6667 61.4188L18.4142 46.1663L22.8764 41.7042L32.9609 51.7498ZM1.33333 41.9997C1.33333 19.552 19.5523 1.33301 42 1.33301C64.4477 1.33301 82.6667 19.552 82.6667 41.9997C82.6667 64.4474 64.4477 82.6664 42 82.6664C19.5523 82.6664 1.33333 64.4474 1.33333 41.9997ZM7.66666 41.9997C7.66666 60.927 23.0727 76.333 42 76.333C60.9273 76.333 76.3333 60.927 76.3333 41.9997C76.3333 23.0724 60.9273 7.66634 42 7.66634C23.0727 7.66634 7.66666 23.0724 7.66666 41.9997Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.b0c8c93d0f6985f204b5a9467d1d5f60.svg";
export { ForwardRef as ReactComponent };